import { Injectable } from '@angular/core';

import { INavData } from './app-sidebar-nav';
import { AppService } from 'src/modules/base/shared/services/app.service';

@Injectable()
export abstract class SidebarNavService {
  /**
   * Returns a sidebar-nav items config NavData
   */
  abstract getSidebarNavItemsConfig(): INavData[];
}

@Injectable()
export class SidebarNavHelper {

  constructor(
    public appService:AppService
  ){
    
  }
  itemType(item) {
    if (item.main) {
      return 'main';
    }else if (item.divider) {
      return 'divider';
    } else if (item.title) {
      return 'title';
    } else if (item.children) {
      return 'dropdown';
    } else if (item.label) {
      return 'label';
    } else if (!Object.keys(item).length) {
      return 'empty';
    } else {
      return 'link';
    }
  }

  public isActive(router, item) {
    return router.isActive(item.url, false);
  }

  public isActiveCustom(router,item) {
    return (this.appService._currentSessionData.nav_id != undefined && this.appService._currentSessionData.nav_id.indexOf(item.id) > -1 );
    //return router.isActive(item.url, false);
  }

  public hasBadge = (item) => Boolean(item.badge);
  public hasIcon = (item) => Boolean(item.icon);
  public hasIconImg(item){
    return (item.icon_name != undefined && item.icon_name)
  }
  public getIconClass(item) {
    const classes = {
      'nav-icon': true
    };
    const icon = item.icon;
    classes[icon] = this.hasIcon(item);
    return classes;
  }
}
